import React, { forwardRef } from 'react';

export const withForwardRef = Component =>
  forwardRef((props, ref) => <Component {...props} ref={ref} />);
